// extracted by mini-css-extract-plugin
module.exports = {"assessmentResultWrapper":"jhhu_wtx","accordion":"e6W7Hjmf","resultTitle":"jT3eafdm","explicitValue":"atFeeB7A","explicitValueBullish":"BmAJiQTf"};